import { useRouter } from "next/navigation";
import Image from "next/image";
import React from "react";
import { formatImageUrl } from "../../../helper/helper";
import Button from "../common/CommonButton/Button";

const SpecialCharity = (props: any) => {
  let bgImage: any = formatImageUrl(
    window.innerWidth <= 760
      ? props?.data?.background_mobile?.data?.attributes?.url
      : props?.data?.background?.data?.attributes?.url
  );

  return (
    <section
      className="the_charity_details_section"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="collection_container">
        <div className="special_charity_div">
          <h2>{props?.data?.title}</h2>
          <p>{props?.data?.description}</p>
          {props?.data?.description_bottom && (
            <p>{props?.data?.description_bottom}</p>
          )}

          {window.innerWidth >= 460 && props?.data?.cta?.link ? (
            <Button
              btnText={props?.data?.cta?.title}
              btnClass={"btn_buy"}
              btnLink={props?.data?.cta?.link}
              linkOpenState={
                props?.data?.cta?.open_in_new_tab == true ? "_blank" : ""
              }
            />
          ) : null}
        </div>
      </div>

      <div className="mobile_journey_image onlyMobile">
        {props?.data?.cta?.link ? (
          <Button
            btnText={props?.data?.cta?.title}
            btnClass={"btn_buy"}
            btnLink={props?.data?.cta?.link}
            linkOpenState={
              props?.data?.cta?.open_in_new_tab == true ? "_blank" : ""
            }
          />
        ) : null}
      </div>
    </section>
  );
};

export default SpecialCharity;
